import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Divider} from "primereact/divider";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputSwitch} from 'primereact/inputswitch';
import {InputTextarea} from "primereact/inputtextarea";
import {Dialog} from "primereact/dialog";
import {Chart} from "primereact/chart";


const UserCredits = props => {
    const lightOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    };

    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [usbID, setusbID] = useState(0);
    const [usbGPULimit, setusbGPULimit] = useState(0);
    const [usbCPULimit, setusbCPULimit] = useState(0);
    const [usbRAMLimit, setusbRAMLimit] = useState(0);
    const [usbDiskLimit, setusbDiskLimit] = useState(0);
    const [limits, setLimits] = useState([]);
    const [creditEditDescription, setcreditEditDescription] = useState("");
    const [acceptDialog, setAcceptDialog] = useState(false);
    const [chartDialog, setChartDialog] = useState(false);
    const [chartData, setCharData] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    "#6eb653",
                    "#a8a6a2"
                ],
                hoverBackgroundColor: [
                    "#6eb65e",
                    "#a8a6a9",
                ]
            }]
    });
    const [globalFilter1, setGlobalFilter1] = useState('');

    const [totalCredit, setTotalCredit] = useState(0);
    const [currentCredit, setCurrentCredit] = useState(0);
    const [usedCredit, setUsedCredit] = useState(0);
    const cloud_configuration_role = localStorage.getItem("cloud_configuration") ? true : false;

    useEffect(() => {
        getCredits();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }


    const getCredits = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/all-user-credit/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setLimits(data.limits);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const updateCredits = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (usbID === null) {
                showError("ID Belirtiniz");
                return;
            }
            if (usbGPULimit === null || usbGPULimit < 0) {
                showError("GPU Limiti 0 veya Daha Fazla Olmalıdır");
                return;
            }
            if (usbCPULimit === null || usbCPULimit < 1) {
                showError("CPU Limiti En Az 1 Olmalıdır");
                return;
            }
            if (usbRAMLimit === null || usbRAMLimit < 1) {
                showError("RAM Limiti En Az 1GB Olmalıdır");
                return;
            }
            if (usbDiskLimit === null || usbDiskLimit < 1) {
                showError("DİSK Limiti En Az 1 GB Olmalıdır");
                return;
            }
            const data = {
                "id": usbID,
                "gpulimit": usbGPULimit,
                "cpulimit": usbCPULimit,
                "ramlimit": usbRAMLimit,
                "disklimit": usbDiskLimit,
                "edit_description": creditEditDescription
            }

            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true);
            fetch("/api/all-user-credit/", {headers, method: "PUT", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            editDialogOnHide();
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const updateLock = (usb_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (usbID === null) {
                showError("ID Seçiniz");
                return;
            }

            const data = {
                "usb_id": usb_id,
            }

            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/user-lock/", {headers, method: "PUT", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            getCredits();
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })

        }
    }

    const getHeader = (value) => {
        return (
            <div align="center">{value}</div>
        );
    }

    const getCreditBody = (compute_key, compute_name) => {
        const creditBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return creditBody;
    }

    const unitConvert = (start_type, number, float_size = 0) => {
        const units = {
            0: "byte",
            1: "KB",
            2: "MB",
            3: "GB",
            4: "TB",
            5: "PB",
            6: "EB",
            7: "ZB",
            8: "YB"
        }
        let type_size = 0;
        for (let i = 0; i < 9; i++) {
            if (units[i] === start_type) {
                type_size = i;
                break;
            }
        }
        while (number > 1024) {
            type_size++;
            number /= 1024;
        }
        while (number < 0) {
            type_size--;
            number *= 1024;
        }

        if (float_size > 0) {
            number = parseFloat(number).toFixed(float_size);
        }

        return [number, units[type_size]];
    }

    const getSizeBody = (compute_key, compute_type_key, compute_name) => {
        const sizeBody = (rowData) => {
            let conv_num = null;
            if(compute_type_key === "ram_type") {
                conv_num = unitConvert("MB", rowData[compute_key], 1);
            } else if (compute_type_key === "disk_type"){
                conv_num = unitConvert("GB", rowData[compute_key], 1);
            }
            let text = "";
            if(conv_num === null){
                text = "";
            } else {
                text = conv_num[0] + " " + conv_num[1];
            }
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ?
                                    text
                                    :
                                    <span>-</span>
                                }
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return sizeBody;
    }

    const processBody = (rowData) => {
        return (
            <React.Fragment>
                <div>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <span className="p-column-title">İŞLEVLER</span>
                        </div>
                        <div className="p-col-12" style={{wordBreak: "break-all"}}>
                            <InputSwitch checked={rowData.lock} onChange={(e) => updateLock(rowData.usb_id)}/>

                            <Button icon="pi pi-pencil"
                                    className="p-button-warning p-mr-2 p-button-text"
                                    onClick={(e) => editDialogDisplay(
                                        rowData.usb_id,
                                        rowData.gpulimit,
                                        rowData.cpulimit,
                                        rowData.ramlimit,
                                        rowData.disklimit)}
                                    tooltip="Düzenle"
                                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                            />

                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    const chartBody = (rowData) => {
        return (
            <React.Fragment>
                <div>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <span className="p-column-title">KREDİ KULLANIM ORANI</span>
                        </div>
                        <div className="p-col-12" style={{wordBreak: "break-all"}}>
                            <Button icon="pi pi-chart-bar" className="p-button-rounded" disabled={rowData.credit === 0}
                                    onClick={(e) => chartDialogOnDisplay(rowData)}/>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    const editDialogDisplay = (usb_id, Gpu_Limit, Cpu_Limit, RAM_Limit, Disk_Limit) => {
        setusbID(usb_id);
        setusbGPULimit(Gpu_Limit);
        setusbCPULimit(Cpu_Limit);
        setusbRAMLimit(unitConvert("MB", RAM_Limit, 0)[0]);
        setusbDiskLimit(Disk_Limit);

        // setAppliedCredit(requested_credit);
        setAcceptDialog(true);
    }

    const editDialogOnHide = () => {
        setAcceptDialog(false);
    }

    const chartDialogOnDisplay = (rowData) => {
        setChartDialog(true);
        const chart_data = {
            labels: ["Kalan Kredi", "Kullanılan Kredi"],
            datasets: [
                {
                    data: [rowData["credit"], rowData["used_credit"]],
                    backgroundColor: [
                        "#6eb653",
                        "#a8a6a2"
                    ],
                    hoverBackgroundColor: [
                        "#6eb65e",
                        "#a8a6a9",
                    ]
                }]
        }
        setCharData(chart_data);
        setTotalCredit(rowData["credit"] + rowData["used_credit"]);
        setCurrentCredit(rowData["credit"]);
        setUsedCredit(rowData["used_credit"]);
    }

    const chartDialogOnHide = () => {
        setChartDialog(false);
    }

    const customer1TableHeader = (
        <div className="table-header">


            <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-10"><h4><b>KULLANICI KAYNAK LİMİTLERİ</b></h4></div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-8 p-xl-2">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"/>
                        <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                                   placeholder="Genel Arama"/>

                    </span>
                </div>
            </div>
        </div>
    );

    if (cloud_configuration_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>

                <div className="datatable-responsive-demo">
                    <div className='card'>
                        <div className="p-grid">

                            <div className="p-col-12">
                                <DataTable
                                    value={limits}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}

                                >
                                    <Column field="user_name"
                                            header="Kullanıcı Adı"
                                            body={getCreditBody("user_name", "Kullanıcı Adı")}
                                            style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column header="Kredi Kullanım Oranı"
                                            body={chartBody}
                                            style={{textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column field="gpulimit"
                                            header="GPU Limiti"
                                            body={getCreditBody("gpulimit", "GPU Limiti")}
                                            style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column field="cpulimit"
                                            header="CPU Limiti"
                                            body={getCreditBody("cpulimit", "CPU Limiti")}
                                            style={{textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column field="ramlimit"
                                            header="RAM Limiti"
                                            body={getSizeBody("ramlimit", "ram_type", "RAM Limiti")}
                                            style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column field="disklimit"
                                            header="DİSK Limiti"
                                            body={getSizeBody("disklimit", "disk_type", "DİSK Limiti")}
                                            style={{textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column header="İşlevler"
                                            body={processBody}
                                            style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog visible={acceptDialog}
                        onHide={editDialogOnHide}
                        header="Düzenle"
                        style={{width: '75%'}}
                        maximizable
                        dismissableMask
                >
                    <div className="p-grid">
                        <Divider align="left">
                            <div className="p-d-inline-flex p-ai-center">
                                <b>Kredi Limitleri</b>
                            </div>
                        </Divider>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="usbCPULimit">CPU Limiti</label>
                                <InputNumber inputId="usbCPULimit"
                                             value={usbCPULimit}
                                             onValueChange={(e) => setusbCPULimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>
                        </div>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="usbGPULimit">GPU Limiti</label>
                                <InputNumber inputId="usbGPULimit"
                                             value={usbGPULimit}
                                             onValueChange={(e) => setusbGPULimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>
                        </div>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="usbRAMLimit">RAM Limiti (GB)</label>
                                <InputNumber inputId="usbRAMLimit"
                                             value={usbRAMLimit}
                                             onValueChange={(e) => setusbRAMLimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>
                        </div>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="usbDiskLimit">DİSK Limiti (GB)</label>
                                <InputNumber inputId="usbDiskLimit"
                                             value={usbDiskLimit}
                                             onValueChange={(e) => setusbDiskLimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>
                        </div>
                        <Divider align="left">
                            <div className="p-d-inline-flex p-ai-center">
                                <b>Kredi Düzenleme Açıklaması</b>
                            </div>
                        </Divider>
                        <div className="p-col-12">
                            <div className="p-field p-md-4" style={{width: '100%'}}>
                                <span className="p-float-label">
                                    <InputTextarea id="creditEditDescription" value={creditEditDescription}
                                                   onChange={(e) => setcreditEditDescription(e.target.value)}
                                                   rows={3}
                                                   style={{width: '100%'}}
                                    />
                                    <label htmlFor="creditEditDescription">Kredi Açıklaması</label>
                                </span>
                            </div>
                        </div>
                        <div className="p-col-12" align="right">
                            <Button label="Güncelle"
                                    className="p-button-success"
                                    icon="pi pi-check"
                                    onClick={(e) => updateCredits()}/>
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={chartDialog}
                        onHide={chartDialogOnHide}
                        header="Kullanıcı Kredi Kullanım Oranı"
                        style={{width: '50%'}}
                        breakpoints={{'960px': '75%'}}
                        maximizable
                        dismissableMask
                >
                    <div className="p-grid">
                        <div className="p-col-12">
                            <div className="p-d-flex p-jc-center">
                                <div className="p-grid" style={{width: "100%"}}>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        <Chart type="doughnut" data={chartData} options={lightOptions}/>
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6"
                                         style={{alignSelf: 'center'}}>
                                        <div className="p-grid">
                                            <div className="p-col-12" style={{width: '100%', wordBreak: "break-all"}}>
                                                <div className="p-grid">
                                                    <div className="p-col-6">
                                                        <strong>Toplam Kredi</strong>
                                                    </div>
                                                    <div className="p-col-6">
                                                        {totalCredit}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-col-12" style={{width: '100%'}}>
                                                <div className="p-grid">
                                                    <div className="p-col-6">
                                                        <strong>Kalan Kredi</strong>
                                                    </div>
                                                    <div className="p-col-6">
                                                        {currentCredit}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-col-12" style={{width: '100%'}}>
                                                <div className="p-grid">
                                                    <div className="p-col-6">
                                                        <strong>Kullanılan Kredi</strong>
                                                    </div>
                                                    <div className="p-col-6">
                                                        {usedCredit}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                {/*<div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <Dropdown inputId="disk_unit" value={diskUnit}
                                      options={disk_unit_options} onChange={onDiskUnitChange}
                                      optionLabel="name"
                            />
                            <label htmlFor="disk_unit">DİSK Birimi</label>
                        </span>
                    </div>*/}

            </div>
        );
    } else {
        return (
            window.location.hash = "/notfound"
        )
    }


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCredits);



// WEBPACK FOOTER //
// ./src/pages/systemmanagement/UserCredits.jsx